import React, { useState } from 'react';
import Modal from '../common/Modal';
import Button from '../common/Button';
import ScorecardView from './ScorecardView';
import Leaderboard from './Leaderboard';

export default function RoundDetailsModal({ round, roundLabel, leaderboard, isOpen, onClose, onViewScorecard }) {
  const [selectedScorecard, setSelectedScorecard] = useState(null);
  const [showScorecard, setShowScorecard] = useState(false);

  if (!round) return null;

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const handleViewScorecard = async (roundPlayerId) => {
    try {
      const scorecard = await onViewScorecard(roundPlayerId);
      setSelectedScorecard(scorecard);
      setShowScorecard(true);
    } catch (err) {
      console.error('Failed to load scorecard:', err);
      alert('Failed to load scorecard');
    }
  };

  if (showScorecard && selectedScorecard) {
    return (
      <Modal
        isOpen={isOpen}
        onClose={() => setShowScorecard(false)}
        title={`Scorecard - ${selectedScorecard.player_name}`}
        size="xl"
      >
        <Button
          variant="secondary"
          onClick={() => setShowScorecard(false)}
          className="mb-4"
        >
          ← Back to Leaderboard
        </Button>
        <div className="max-h-[70vh] overflow-y-auto pr-2">
          <ScorecardView scorecard={selectedScorecard} round={round} roundLabel={roundLabel} />
        </div>
      </Modal>
    );
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Round Results"
      size="xl"
    >
      <div className="space-y-4">
        {/* Round Header */}
        <div className="bg-gradient-to-r from-primary to-secondary text-white rounded-lg p-6">
          <h3 className="text-2xl font-bold mb-2">{round.course_name}</h3>
          <p className="text-base opacity-90 mb-4">{round.course_location}</p>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <p className="opacity-80">Started</p>
              <p className="font-semibold">{formatDate(round.start_date)}</p>
            </div>
            {round.end_date && (
              <div>
                <p className="opacity-80">Completed</p>
                <p className="font-semibold">{formatDate(round.end_date)}</p>
              </div>
            )}
          </div>
        </div>

        {/* Final Leaderboard using main Leaderboard component */}
        <div>
          <h4 className="text-xl font-bold text-gray-900 mb-3">Final Standings</h4>
          <div className="max-h-[60vh] overflow-y-auto">
            <Leaderboard leaderboard={leaderboard} round={round} />
          </div>
        </div>

        {/* Close Button */}
        <div className="flex justify-end pt-4 border-t border-gray-200">
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
}
